module.exports = __webpack_public_path__ + "img/Holiday e-Cards Intro Popup.dddaaff.png";